import classes from "../styles/blog.module.css";
import BlogSearchBox from "../components/blogSearchBox";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import BlogCategoryCard from "../components/blogCategoryCard";
import BlogsSection from "../components/blogsSection";
import { trackEvent } from "@utils/analytics/event-analytics";
import { WEB_ENGAGE } from "@utils/constants";
import InfiniteScroll from "react-infinite-scroll-component";
import { getBlogPosts } from "@queries/blogs.queries";
function BlogsView({
  data
}) {
  const {
    t
  } = useTranslation();
  const [showSearch, setShowSearch] = useState(false);
  const [blogs, setBlogs] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [search, setSearch] = useState("");
  const [blogPage, setBlogPage] = useState(0);
  useEffect(() => {
    trackEvent(WEB_ENGAGE.SCREEN_NAMES.HOME_BLOG + " " + WEB_ENGAGE.EVENT_NAMES.SCREEN_VIEWED, {
      [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.HOME_BLOG
    });
  }, []);
  useEffect(() => {
    if (data) {
      setBlogs(data.blogsData);
    }
  }, [data]);
  const fetchMoreBlogs = async () => {
    if (!hasMore) {
      return;
    }
    const page = blogPage + 1;
    const {
      data: newBlogs,
      err
    } = await getBlogPosts({
      page
    });
    if (err) {
      setHasMore(false);
    } else {
      if (newBlogs.blogsData.length === 0) {
        setHasMore(false);
      } else {
        setBlogs(prevBlogs => [...prevBlogs, ...newBlogs.blogsData]);
        setBlogPage(page);
      }
    }
  };
  return <div className={classes.blogPage} data-sentry-component="BlogsView" data-sentry-source-file="BlogsView.jsx">
      {/* bannerSection */}{" "}
      <div className={classes.blogBanner}>
        <div className={classes.searchBox}>
          <BlogSearchBox setHasMore={setHasMore} setShowSearch={setShowSearch} setBlogs={setBlogs} setSearch={setSearch} search={search} blogPage={blogPage} setBlogPage={setBlogPage} data-sentry-element="BlogSearchBox" data-sentry-source-file="BlogsView.jsx" />
        </div>
      </div>
      {/* bannerSection */}
      {/* categorySection */}
      {!showSearch && <div className={classes.blogCategories}>
          {/* <h2 className={`${classes.blogSectionHeading} ${classes.noCopy}`}>
            {t("hindu-gyan-ke-bhag")}
           </h2> */}

          {/* <div className={classes.blogCategoryContainer}>
            {data?.blogsCategory?.map(
              (pujaCategory, index) =>
                index % 2 == 0 && (
                  <BlogCategoryCard
                    pujaCategory={pujaCategory}
                    key={pujaCategory.categoryID}
                  />
                )
            )}
           </div>
           <div className={classes.blogCategoryContainer}>
            {data?.blogsCategory?.map(
              (pujaCategory, index) =>
                index % 2 != 0 && (
                  <BlogCategoryCard
                    pujaCategory={pujaCategory}
                    key={pujaCategory.categoryID}
                  />
                )
            )}
           </div> */}
          <div className={classes.blogCategoryContainer}>
            {data?.blogsCategory?.map((pujaCategory, index) => <BlogCategoryCard pujaCategory={pujaCategory} key={pujaCategory.categoryID} />)}
          </div>
        </div>}
      {/* categorySection */}
      {/* blogsSection */}
      <div className={classes.blogsSection}>
        <InfiniteScroll dataLength={blogs.length} next={fetchMoreBlogs} hasMore={hasMore} loader={<h4>Loading...</h4>} data-sentry-element="InfiniteScroll" data-sentry-source-file="BlogsView.jsx">
          {blogs?.map((blogsData, index) => blogsData?.blogData.length > 0 && <BlogsSection blogsData={blogsData} key={index} />)}
        </InfiniteScroll>
      </div>
      {/* blogsSection */}
    </div>;
}
export default BlogsView;